import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonLabel, IonFab, IonFabButton, IonIcon, useIonModal, IonButtons, IonButton } from '@ionic/react';
import { useState, useEffect } from 'react';
import { addSmsTemplateListener } from '../firebase/smsTemplates';
import { addOutline, chevronBack } from 'ionicons/icons';
import { useHistory } from 'react-router';
import SmsTemplateEditor from './SmsTemplateEditor';

const SmsTempalesPage: React.FC = () => {
  const history = useHistory();
  const [templates, setTemplates] = useState([]);
  const [template, setTemplate] = useState({});

  useEffect(() => {
    addSmsTemplateListener((list: any) => {
      setTemplates(list);
    });
  }, []);

  const [presentEditor, dismissEditor] = useIonModal(SmsTemplateEditor, {
    template: template,
    onDismiss: () => dismissEditor()
  });

  function openEditor(e: any = null) {
    if (e !== null) {
      setTemplate(e);
    } else {
      setTemplate({})
    }

    presentEditor();
  }

  return (
    <IonPage >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton color="medium" onClick={history.goBack}>
              <IonIcon icon={chevronBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Szablony SMS</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>


        {templates.map((t: any) => (
          <IonItem onClick={(e) => { openEditor(t) }} key={t.id} >
            <IonLabel>{t.topic}</IonLabel>
          </IonItem>
        ))}

        <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonFabButton onClick={() => { openEditor() }}>
            <IonIcon icon={addOutline}></IonIcon>
          </IonFabButton>
        </IonFab>
      </IonContent>
    </IonPage>
  );
};

export default SmsTempalesPage;
